import OrdersSection from "features/tradingTerminal/Orders/OrdersSection";
import useTradeGeneralConfiguration from "features/tradingTerminal/Orders/useTradeGeneralConfiguration";
import { OrderTypes } from "@shared/types";
import useSharedOrders from "@shared/features/tradingTerminal/SmartTrade/useSharedOrders";

const useOrders = () => {
  const takeProfitsData = useTradeGeneralConfiguration(
    OrderTypes.TAKE_PROFIT,
    true,
    true
  );

  const entriesData = useTradeGeneralConfiguration(
    OrderTypes.ENTRY,
    true,
    true
  );

  const stopData = useTradeGeneralConfiguration(OrderTypes.STOP, false, true);

  const generalConfigurationData = {
    [OrderTypes.ENTRY]: entriesData,
    [OrderTypes.TAKE_PROFIT]: takeProfitsData,
    [OrderTypes.STOP]: stopData,
  };

  const {
    orders,
    setOrders,
    useOrdersByType,
    setUseOrdersByType,
    getBaselineEntryPrice,
    ordersErrors,
  } = useSharedOrders(generalConfigurationData);

  const getOrdersSection = (orderType: OrderTypes) => {
    return (
      <OrdersSection
        orderType={orderType}
        orders={orders[orderType]}
        setOrders={setOrders[orderType]}
        ordersErrors={ordersErrors?.[orderType]}
        useOrders={useOrdersByType[orderType]}
        setUseOrders={setUseOrdersByType[orderType]}
        baselineEntryPrice={getBaselineEntryPrice(orderType)}
        generalConfigurationData={generalConfigurationData[orderType]}
        key={orderType}
      />
    );
  };

  const orderTypeToOrdersSection: Record<OrderTypes, React.JSX.Element> = {
    [OrderTypes.ENTRY]: getOrdersSection(OrderTypes.ENTRY),
    [OrderTypes.TAKE_PROFIT]: getOrdersSection(OrderTypes.TAKE_PROFIT),
    [OrderTypes.STOP]: getOrdersSection(OrderTypes.STOP),
  };

  return orderTypeToOrdersSection;
};

export default useOrders;
